import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SpenLink } from '@classi/spen';

@Component({
  selector: 'app-password-notes',
  imports: [SpenLink],
  templateUrl: './password-notes.component.html',
  styleUrls: ['./password-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordNotesComponent {}
